
import Services from './base-services'

const service = new Services('countries')

export default {
  listFromSuite: () => {
    return service.suiteOperation(() => service.get('list-by-enterprise'))
  }
}
